import type { FilterRowValue } from './FilterRow';

export function scalarOf(value: FilterRowValue): string | number {
  return Array.isArray(value) ? '' : value;
}
